<template>
  <div class="mb-5">

    <!--
    <div>
      <h3>
        Импорт данных о плательщиках из MySQL в ClickHouse
      </h3>

      <table class="prop-table mb-2">
        <tr>
          <th>Таблица в MySQL</th>
          <td><code>month_payer_billing</code></td>
        </tr>
        <tr>
          <th>Таблица в ClickHouse</th>
          <td><code>month_payer_billing</code></td>
        </tr>
      </table>

      <b-button
        @click="importMonthPayerBillingGroupsToClickHouse"
      >
        Import month payer billing groups from MySQL to ClickHouse
      </b-button>
    </div>
    -->

    <!--
    <table class="prop-table mb-4">
      <tr>
        <th>Time begin</th>
        <td>{{ timeBegin | getMomentStr }}</td>
      </tr>
      <tr>
        <th>Time end</th>
        <td>{{ timeEnd | getMomentStr }}</td>
      </tr>
      <tr>
        <th>Save time end</th>
        <td>{{ saveTimeEnd | getMomentStr }}</td>
      </tr>
    </table>
    -->

    <div class="mb-3">
      <p>
        Перед загрузкой отчетов по возвратам (retention)
        нужно проверить, что таблица <code>month_activity</code>
        в ClickHouse содержит данные за требуемые месяцы.
        В таблицу <code>month_activity</code> нужно импортировать данные
        из&nbsp;следующих таблиц.      
      </p>
      <ul class="mb-2">
        <li>таблица <code>event_m3_level_finished_prep</code> (ClickHouse)</li>
        <li>таблица <code>billing</code> (MySQL)</li>
      </ul>
      <p>
        После выполнения задачи<br>
        Сохранение события "Запуск игры"<br>
        <a href="https://app.asana.com/0/1200345753930577/1201182341552064">https://app.asana.com/0/1200345753930577/1201182341552064</a><br>
        требуемые данные за все месяцы будут актуальны автоматически.
      </p>
    </div>

    <!--
    <b-button @click="importMonthActivePlayersToClickHouse">
      Import month active players to ClickHouse
    </b-button>
    -->

    <hr>

    <div class="mb-3">
      <b-button @click="loadtMonthNewPayersReport">
        Download report "Month new payers"
      </b-button>
    </div>

    <div class="mb-3">
      <b-button @click="loadtNewPayerRevenueReport">
        Download report "New payer revenue"
      </b-button>
    </div>

    <hr>

    <h2 class="mb-3">Retention</h2>

    <ol class="button-list mb-3">
      <li>
        <b-button @click="loadMonthPayerRetentionReportTable">
          Download report "Month payer retention" таблица
        </b-button>
      </li>
      <li>
        <b-button @click="loadMonthPayerRetentionReportTriangle">
          Download report "Month payer retention" треугольник
        </b-button>
      </li>
    </ol>

    <ol class="button-list">
      <li>
        <b-button
          @click="loadMonthPayerRetentionReportForQuartileTable(1)"
        >
          Download report "Month payer retention for quartile 1 (top 25%)" таблица
        </b-button>
      </li>
      <li>
        <b-button
          @click="loadMonthPayerRetentionReportForQuartileTriangle(1)"
        >
          Download report "Month payer retention for quartile 1 (top 25%)" треугольник
        </b-button>
      </li>
      <li>
        <b-button
          @click="loadMonthPayerRetentionReportForQuartileTable(2)"
        >
          Download report "Month payer retention for quartile 2 (25-50%)" таблица
        </b-button>
      </li>
      <li>
        <b-button
          @click="loadMonthPayerRetentionReportForQuartileTriangle(2)"
        >
          Download report "Month payer retention for quartile 2 (25-50%)" треугольник
        </b-button>
      </li>
      <li>
        <b-button
          @click="loadMonthPayerRetentionReportForQuartileTable(3)"
        >
          Download report "Month payer retention for quartile 3 (50-75%)" таблица
        </b-button>
      </li>
      <li>
        <b-button
          @click="loadMonthPayerRetentionReportForQuartileTriangle(3)"
        >
          Download report "Month payer retention for quartile 3 (50-75%)" треугольник
        </b-button>
      </li>
      <li>
        <b-button
          @click="loadMonthPayerRetentionReportForQuartileTable(4)"
        >
          Download report "Month payer retention for quartile 4 (75-100%)" таблица
        </b-button>
      </li>
      <li>
        <b-button
          @click="loadMonthPayerRetentionReportForQuartileTriangle(4)"
        >
          Download report "Month payer retention for quartile 4 (75-100%)" треугольник
        </b-button>
      </li>
    </ol>

    <hr>

    <h2 class="mb-3">Revenue</h2>
    
    <div class="mb-3">
      <b-button @click="loadPayerQuartileRevenueReport">
        Download report "Payer quartile revenue"
      </b-button>
    </div>

    <ol class="button-list mb-3">
      <li>
        <b-button @click="loadMonthPayerRevenueReportTable">
          Download report "Month payer revenue" таблица
        </b-button>
      </li>
      <li>
        <b-button @click="loadMonthPayerRevenueReportTriangle">
          Download report "Month payer revenue" треугольник
        </b-button>
      </li>
    </ol>

    <ol class="button-list">
      <li>
        <b-button
          @click="loadMonthPayerRevenueReportForQuartileTable(1)"
        >
          Download report "Month payer revenue for quartile 1 (top 25%)" таблица
        </b-button>
      </li>
      <li>
        <b-button
          @click="loadMonthPayerRevenueReportForQuartileTriangle(1)"
        >
          Download report "Month payer revenue for quartile 1 (top 25%)" треугольник
        </b-button>
      </li>
      <li>
        <b-button
          @click="loadMonthPayerRevenueReportForQuartileTable(2)"
        >
          Download report "Month payer revenue for quartile 2 (25-50%)" таблица
        </b-button>
      </li>
      <li>
        <b-button
          @click="loadMonthPayerRevenueReportForQuartileTriangle(2)"
        >
          Download report "Month payer revenue for quartile 2 (25-50%)" треугольник
        </b-button>
      </li>
      <li>
        <b-button
          @click="loadMonthPayerRevenueReportForQuartileTable(3)"
        >
          Download report "Month payer revenue for quartile 3 (50-75%)" таблица
        </b-button>
      </li>
      <li>
        <b-button
          @click="loadMonthPayerRevenueReportForQuartileTriangle(3)"
        >
          Download report "Month payer revenue for quartile 3 (50-75%)" треугольник
        </b-button>
      </li>
      <li>
        <b-button
          @click="loadMonthPayerRevenueReportForQuartileTable(4)"
        >
          Download report "Month payer revenue for quartile 4 (75-100%)" таблица
        </b-button>
      </li>
      <li>
        <b-button
          @click="loadMonthPayerRevenueReportForQuartileTriangle(4)"
        >
          Download report "Month payer revenue for quartile 4 (75-100%)" треугольник
        </b-button>
      </li>
    </ol>

    <hr>

    <h2 class="mb-3">Статистика по платежам на iOS</h2>

    <p>
      Отчет создается для определенного периода.
    </p>
    <p>
      Рассматриваются только те игроки, для которых выполняются 2 условия:
    </p>
    <ol class="mb-2">
      <li>Игрок зарегистрировался в указанный период.</li>
      <li>Сумма платежей игрока в течение первых 3-х дней после регистрации больше 0.</li>
    </ol>
    <p class="mb-2">
      В отчете для каждого плательщика (который зарегистрировался в указанном периоде)
      приведена сумма платежей за первые 3 дня после регистрации.
    </p>

    <b-button @click="loadIOSNewPayersReport">
      Сохранить отчет "Статистика по платежам на iOS"
    </b-button>

    <hr>

  </div>
</template>

<script>
import { HTTP } from '../http-common.js';
import notifier from '../notifier.js';

/**
 * @typedef { import("../model/cohort.js").CohortReport } CohortReport
 */

import {convertObjectToCohortReport} from '../model/cohort.js';
import {convertCohortReportToString} from '../model/cohort.js';

import {convertObjectToPlayerRevenueReport} from '../model/stat_revenue.js';
import {convertPlayerRevenueReportToString} from '../model/stat_revenue.js';

//-----------------------------------------------------------------------------

import {
  parseReport as parseRevenueReport
} from '../model/stat/revenue/report_parser.js';

import {
  convertReportToTableString as convertRevenueReportToTableString
} from '../model/stat/revenue/converter__report_to_table_string.js';

import {
  convertReportToTriangleString as convertRevenueReportToTriangleString
} from '../model/stat/revenue/converter__report_to_triangle_string.js';

import {
  convertReportToQuartileTableString as convertRevenueReportToQuartileTableString
} from '../model/stat/revenue/converter__report_to_quartile_table_string.js';

//-----------------------------------------------------------------------------

import {convertObjectToPayerQuartileRevenueReport} from '../model/stat_revenue_qurtile_report.js';
import {convertPayerQuartileRevenueReportToString} from '../model/stat_revenue_qurtile_report.js';

import {convertObjectToRetentionReport             } from '../model/stat/retention_report_parser.js';
import {convertRetentionReportToTableString        } from '../model/stat/converter__retention_report_to_table_string.js';
import {convertRetentionReportToTriangleString     } from '../model/stat/converter__retention_report_to_triangle_string.js';
import {convertRetentionReportToQuartileTableString} from '../model/stat/converter__retention_report_to_quartile_table_string.js';

import {convertYearMonthPeriodToInclusiveString} from '../time.js';

import saveAs from 'file-saver';

export default {
  name: 'SystemStat',

  data() {
    return {
      timeBegin:   1704056400,
      timeEnd:     1719781200,
      saveTimeEnd: 1720990800,
    };
  },

  methods: {
    /*
    importMonthActivePlayersToClickHouse() {
      notifier.deleteSenderNotifications(this);

      const url = `/stat/import_month_active_players_to_clickhouse`;

      const data = new FormData();
      data.set('time_begin',    this.timeBegin.toString());
      data.set('time_end',      this.timeEnd.toString());
      data.set('save_time_end', this.saveTimeEnd.toString());

      HTTP.post(url, data)
      .then(() => {
        notifier.showSuccess('Data imported to ClickHouse.');
      })
      .catch(err => {
        notifier.showError(err, {sender: this});
      });
    },
    */

    loadtMonthNewPayersReport() {
      notifier.deleteSenderNotifications(this);

      const url = '/stat/month_new_payers';
      HTTP.get(url)
      .then(response => {
        const reportObject = response.data.data;
        const report = convertObjectToCohortReport(reportObject);
        if(report === null) {
          notifier.showError('Report parsing error.', {sender: this});
          return;
        }

        const periodStr = convertYearMonthPeriodToInclusiveString(report.period);
        const fileName = `period_${periodStr}__month_new_payers.csv`;
  
        const reportStr = convertCohortReportToString(report);

        saveAs(new Blob([reportStr]), fileName);
      })
      .catch(err => {
        notifier.showError(err, {sender: this});
      });
    },

    loadtNewPayerRevenueReport() {
      notifier.deleteSenderNotifications(this);

      const url = '/stat/new_payer_revenue';
      HTTP.get(url)
      .then(response => {
        const reportObject = response.data.data;
        const report = convertObjectToPlayerRevenueReport(reportObject);
        if(report === null) {
          notifier.showError('Player revenue report parsing error.', {sender: this});
          return;
        }

        const periodStr = convertYearMonthPeriodToInclusiveString(report.period);
        const fileName = `period_${periodStr}_new_payer_revenue.csv`;
  
        const reportStr = convertPlayerRevenueReportToString(report);

        saveAs(new Blob([reportStr]), fileName);
      })
      .catch(err => {
        notifier.showError(err, {sender: this});
      });
    },

    loadMonthPayerRetentionReportTable() {
      notifier.deleteSenderNotifications(this);

      const url = '/stat/month_payer_retention';
      HTTP.get(url)
      .then(response => {
        const reportObject = response.data.data;

        const report = convertObjectToRetentionReport(reportObject);
        if(report === null) {
          notifier.showError('Report parsing error.', {sender: this});
          return;
        }

        const periodStr = convertYearMonthPeriodToInclusiveString(report.period);
        const fileName = `${periodStr}_payer_retention_table.csv`;
  
        const reportStr = convertRetentionReportToTableString(report);

        saveAs(new Blob([reportStr]), fileName);
      })
      .catch(err => {
        notifier.showError(err, {sender: this});
      });
    },

    loadMonthPayerRetentionReportTriangle() {
      notifier.deleteSenderNotifications(this);

      const url = '/stat/month_payer_retention';
      HTTP.get(url)
      .then(response => {
        const reportObject = response.data.data;

        const report = convertObjectToRetentionReport(reportObject);
        if(report === null) {
          notifier.showError('Report parsing error.', {sender: this});
          return;
        }

        const periodStr = convertYearMonthPeriodToInclusiveString(report.period);
        const fileName = `${periodStr}_payer_retention_triangle.csv`;
  
        const reportStr = convertRetentionReportToTriangleString(report);

        saveAs(new Blob([reportStr]), fileName);
      })
      .catch(err => {
        notifier.showError(err, {sender: this});
      });
    },

    /**
     * @param {number} quartileNumber (1, 2, 3 or 4).
     */
    loadMonthPayerRetentionReportForQuartileTable(quartileNumber) {
      notifier.deleteSenderNotifications(this);

      const url = `/stat/month_payer_retention/quartile/${quartileNumber}`;
      HTTP.get(url)
      .then(response => {
        const reportObject = response.data.data;

        const report = convertObjectToRetentionReport(reportObject);
        if(report === null) {
          notifier.showError('Report parsing error.', {sender: this});
          return;
        }

        const periodStr = convertYearMonthPeriodToInclusiveString(report.period);
        const fileName = `${periodStr}_payer_retention_quartile_${quartileNumber}_table.csv`;

        const reportStr = convertRetentionReportToQuartileTableString(quartileNumber, report);

        saveAs(new Blob([reportStr]), fileName);
      })
      .catch(err => {
        notifier.showError(err, {sender: this});
      });
    },

    /**
     * @param {number} quartileNumber (1, 2, 3 or 4).
     */
    loadMonthPayerRetentionReportForQuartileTriangle(quartileNumber) {
      notifier.deleteSenderNotifications(this);

      const url = `/stat/month_payer_retention/quartile/${quartileNumber}`;
      HTTP.get(url)
      .then(response => {
        const reportObject = response.data.data;

        const report = convertObjectToRetentionReport(reportObject);
        if(report === null) {
          notifier.showError('Report parsing error.', {sender: this});
          return;
        }

        const periodStr = convertYearMonthPeriodToInclusiveString(report.period);
        const fileName = `${periodStr}_payer_retention_quartile_${quartileNumber}_triangle.csv`;

        const reportStr = convertRetentionReportToTriangleString(report);

        saveAs(new Blob([reportStr]), fileName);
      })
      .catch(err => {
        notifier.showError(err, {sender: this});
      });
    },

    loadPayerQuartileRevenueReport() {
      notifier.deleteSenderNotifications(this);

      const url = '/stat/payer_quartiles_info';
      HTTP.get(url)
      .then(response => {
        const reportObject = response.data.data;

        const report = convertObjectToPayerQuartileRevenueReport(reportObject);
        if(report === null) {
          notifier.showError('Report parsing error.', {sender: this});
          return;
        }

        const periodStr = convertYearMonthPeriodToInclusiveString(report.getPeriod());
        const fileName = `${periodStr}_payer_quartiles_revenue.csv`;
  
        const reportStr = convertPayerQuartileRevenueReportToString(report);

        saveAs(new Blob([reportStr]), fileName);
      })
      .catch(err => {
        notifier.showError(err, {sender: this});
      });
    },

    loadMonthPayerRevenueReportTable() {
      notifier.deleteSenderNotifications(this);

      const url = '/stat/month_payer_revenue';
      HTTP.get(url)
      .then(response => {
        const reportObject = response.data.data;

        const report = parseRevenueReport(reportObject);

        if(report === null) {
          notifier.showError('Report parsing error.', {sender: this});
          return;
        }

        const periodStr = convertYearMonthPeriodToInclusiveString(report.getPeriod());
        const fileName = `${periodStr}_payer_revenue_table.csv`;
  
        const reportStr = convertRevenueReportToTableString(report);

        saveAs(new Blob([reportStr]), fileName);
      })
      .catch(err => {
        notifier.showError(err, {sender: this});
      });
    },

    loadMonthPayerRevenueReportTriangle() {
      notifier.deleteSenderNotifications(this);

      const url = '/stat/month_payer_revenue';
      HTTP.get(url)
      .then(response => {
        const reportObject = response.data.data;

        const report = parseRevenueReport(reportObject);

        if(report === null) {
          notifier.showError('Report parsing error.', {sender: this});
          return;
        }

        const periodStr = convertYearMonthPeriodToInclusiveString(report.getPeriod());
        const fileName = `${periodStr}_payer_revenue_triangle.csv`;
  
        const reportStr = convertRevenueReportToTriangleString(report);

        saveAs(new Blob([reportStr]), fileName);
      })
      .catch(err => {
        notifier.showError(err, {sender: this});
      });
    },

    /**
     * Data output form: list.
     * @param {number} quartileNumber (1, 2, 3 or 4).
     */
    loadMonthPayerRevenueReportForQuartileTable(quartileNumber) {
      notifier.deleteSenderNotifications(this);

      const url = `/stat/month_payer_revenue/quartile/${quartileNumber}`;
      HTTP.get(url)
      .then(response => {
        const reportObject = response.data.data;

        const report = parseRevenueReport(reportObject);
        if(report === null) {
          notifier.showError('Report parsing error.', {sender: this});
          return;
        }

        const periodStr = convertYearMonthPeriodToInclusiveString(report.getPeriod());
        const fileName = `${periodStr}_payer_revenue_quartile_${quartileNumber}_table.csv`;

        const reportStr = convertRevenueReportToQuartileTableString(quartileNumber, report);

        saveAs(new Blob([reportStr]), fileName);
      })
      .catch(err => {
        notifier.showError(err, {sender: this});
      });
    },

    /**
     * @param {number} quartileNumber (1, 2, 3 or 4).
     */
    loadMonthPayerRevenueReportForQuartileTriangle(quartileNumber) {
      notifier.deleteSenderNotifications(this);

      const url = `/stat/month_payer_revenue/quartile/${quartileNumber}`;
      HTTP.get(url)
      .then(response => {
        const reportObject = response.data.data;

        const report = parseRevenueReport(reportObject);
        if(report === null) {
          notifier.showError('Report parsing error.', {sender: this});
          return;
        }

        const periodStr = convertYearMonthPeriodToInclusiveString(report.getPeriod());
        const fileName = `${periodStr}_payer_revenue_quartile_${quartileNumber}_triangle.csv`;

        const reportStr = convertRevenueReportToTriangleString(report);

        saveAs(new Blob([reportStr]), fileName);
      })
      .catch(err => {
        notifier.showError(err, {sender: this});
      });
    },

    loadIOSNewPayersReport() {
      notifier.deleteSenderNotifications(this);

      const url = '/stat/ios_new_payers_report';
      HTTP.get(url)
      .then(response => {
        const reportObject = response.data.data;
        console.log(reportObject);

        const payers = reportObject.payers;

        const fileName = 'report.csv';
        const reportStr = convertNewPayersReportToString(payers);
        saveAs(new Blob([reportStr]), fileName);
      })
      .catch(err => {
        notifier.showError(err, {sender: this});
      });
    },

/*
    importMonthPayerBillingGroupsToClickHouse() {
      notifier.deleteSenderNotifications(this);

      const url = '/stat/month_payer_billing_groups/import_to_clickhouse';
      HTTP.post(url)
      .then(response => {
        notifier.showSuccess('Data imported to ClickHouse.');
      })
      .catch(err => {
        notifier.showError(err, {sender: this});
      });
    },
*/
  },
};

function convertNewPayersReportToString(payers) {
  let str = 'player_id,payment_sum\n';

  if(payers !== null) {
    for(const payer of payers) {
      str += payer.id + ',' + payer.paymentSum + '\n';
    }  
  }

  return str;
}

</script>

<style scoped>
.button-list {
  list-style-type: none;
  padding-left: 0;
}

.button-list > li {
  margin-bottom: 0.2rem;
}

p {
  max-width: 600px;
}
</style>